<script>
export default {
};
</script>
<template>
    <transition name="fade">
        <slot></slot>
    </transition>
</template>
<style lang="stylus" scoped>
.fade-enter, .fade-leave-to
    opacity 0
.fade-enter-to, .fade-leave
    opacity 1
.fade-enter-active, .fade-leave-active
    transition opacity 225ms cubic-bezier(0, 0, 0.2, 1) 0ms
</style>